import { IconButton, Typography } from '@mui/material';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import { Project } from '../../models/project';
import { useNavigate } from 'react-router-dom';
import { ContactsCount } from '../contacts/contacts-count-grid-cell';
import { GridCountCell } from '../../components/grid-cell-count';
import { UserPermissionName } from '../../models/user-permission-name';
import { useAuthorize } from '../../hooks/use-authorize';

interface CustomGridCellProps {
  field: string;
  customerID?: number;
}

interface CellProps {
  project: Project;
  customerID?: number;
}

const styling = {
  iconStyle: { color: '$primary-color' },
  textStyle: { paddingLeft: '5px', color: '$primary-color' },
};

const ContactsCountCell = ({ project }: CellProps) => {
  return (
    <ContactsCount
      count={project.projectContactsCount}
      customerID={project.customerID}
      officeID={project.officeID}
      projectID={project.projectID}
    />
  );
};

const UnitsCountCell = ({ project }: CellProps) => {
  const isUnitViewPermission = useAuthorize([UserPermissionName.VIEW_UNIT]);
  return (
    <GridCountCell
      count={project.unitsCount}
      icon={<HomeWorkOutlinedIcon style={styling.iconStyle} />}
      route={`/units?customerID=${project.customerID}&officeID=${project.officeID}&projectID=${project.projectID}`}
      isDisabled={!isUnitViewPermission || project?.isCompleted}
    />
  );
};

const WorkOrdersCountCell = ({ project }: CellProps) => {
  const isWorkOrderViewPermission = useAuthorize([UserPermissionName.VIEW_WORKORDER]);
  return (
    <GridCountCell
      count={project.workOrderCount}
      icon={<HomeWorkOutlinedIcon style={styling.iconStyle} />}
      route={`/workorders?customerID=${project.customerID}&officeID=${project.officeID}&projectID=${project.projectID}`}
      isDisabled={!isWorkOrderViewPermission || project?.isCompleted}
    />
  );
};

export const ProjectCustomGridCell = ({ field }: CustomGridCellProps) => {
  if (field === 'projectContactsCount') {
    return (dataItem: any) => {
      return <ContactsCountCell project={dataItem.dataItem} />;
    };
  }
  if (field === 'unitsCount') {
    return (dataItem: any) => {
      return <UnitsCountCell project={dataItem.dataItem} />;
    };
  }
  if (field === 'workOrderCount') {
    return (dataItem: any) => {
      return <WorkOrdersCountCell project={dataItem.dataItem} />;
    };
  }
};
